module.exports = __webpack_public_path__ + "img/retailer-links.2cf6f8a3.jpg";